export const USDFormatter = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
});

export function currencyFormatter(currency: string) {
	return new Intl.NumberFormat("en-US", {
		style: "currency",
		currency,
	});
}
